import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';


const CONTENT_ITEMS = [
    {
        title: { ko: '리깅 모드 지원', en: 'Rigging Mode' },
        description: {
        ko: '외부 툴을 사용하지 않고도 직접 뼈대와 가중치 작업을 수행할 수 있습니다. 모델에 본을 배치하고 스킨 가중치를 조정하여 자연스럽고 정밀한 애니메이션을 구현할 수 있으며, 보다 효율적인 워크플로우를 경험할 수 있습니다.',
        en: 'Perform bone placement and skin weighting directly  within Rigging Mode—no external tools needed.  Achieve natural, precise animations while streamlining your workflow.',
        },
        video: "/m3u8/rg_01.m3u8",
        thum: require("../../assets/thumnails/rg_01_thum.webp"),
        reverse: false
    },
    {
        title: { ko: '오토 리깅', en: 'Auto Rigging' },
        description: {
        ko: '3D 모델을 자동으로 분석하여 기본 뼈대와 가중치를 생성하세요. 복잡한 리깅 과정을 최소화하면서 모델 구조에 맞는 본 배치와 스킨 가중치를 적용할 수 있습니다. 이를 통해 캐릭터 애니메이션과 동작 구현을 더욱 빠르고 효율적으로 진행하며, 높은 완성도를 유지할 수 있습니다.',
        en: 'Automatically analyze 3D models to generate bones and weights.  Minimize complex rigging steps while applying precise bone  placement and skin weighting. Speed up character animation  with an efficient, high-quality workflow.'},
        video: "/m3u8/rg_02.m3u8",
        thum: require("../../assets/thumnails/rg_02_thum.webp"),
        reverse: true
    },
    {
        title: { ko: '웨이트 트랜스퍼', en: 'Weight Transfer' },
        description: {
        ko: '다른 모델의 스키닝 데이터를 가져와 손쉽게 적용하세요. 기존 본 구조와 스킨 가중치를 재사용해 반복 작업을 줄이고, 효율적으로 애니메이션을 제작할 수 있습니다.',
        en: 'Easily transfer skinning data from one model to another.  Reuse existing bone structures and skin weights  to reduce repetitive tasks and streamline animation production.'
        },
        video: "/m3u8/rg_03.m3u8",
        thum: require("../../assets/thumnails/rg_03_thum.webp"),
        reverse: false
    },
    {
        title: { ko: '휴머노이드 아바타 지원', en: 'Humanoid Avatar Support' },
        description: {
        ko: '인간형 캐릭터의 리깅 과정을 간소화해 효율적으로 작업하세요. 자동화된 리깅 시스템을 활용해 기본 뼈대를 설정하고, Unity의 휴머노이드 애니메이션을 즉시 적용할 수 있습니다.',
        en: 'Streamline humanoid character rigging with an automated system.  Set up basic bones easily and apply Unity humanoid animations instantly.'
        },
        video: "/m3u8/rg_04.m3u8",
        thum: require("../../assets/thumnails/rg_04_thum.webp"),
        reverse: true
    }
];

export default function Rigging() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '리깅과 스키닝' : 'Rigging & Skinning'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? '리깅 모드로 3D 모델에 생명력을 불어넣으세요.' : 'Add life to your 3D models using rigging mode.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                </>
                            ) : (
                                <>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    리깅과 스키닝까지 유니티 안에서
                                </>
                                :
                                <>
                                    Rigging & Skinning Directly in Unity
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>                            
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                                style={{width: 220,}}
                            >
                                {lang === 0 ? '영업팀에 문의' : 'Contact Us'}
                            </button>


                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
